import { createApp, h } from 'vue';
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import LoadScript from 'vue-plugin-load-script';
import * as Sentry from '@sentry/vue';
import { createPinia } from 'pinia';
import Toast from 'vue-toastification';
import { ENVIRONMENT, APP_DOMAIN } from './Utils/vice-constants';

import AppFooterWrapper from '@/Layouts/AppFooterWrapper.vue';

import 'vue-toastification/dist/index.css';
import 'vue-tel-input/dist/vue-tel-input.css';

require('./bootstrap');

const el = document.getElementById('app');

const options = {
  hideProgressBar: true,
  pauseOnHover: true,
  showCloseButtonOnHover: true,
  timeout: 5000,
  transition: 'Vue-Toastification__fade',
};

createApp({
  render: () =>
    h(AppFooterWrapper, null, () =>
      h(InertiaApp, {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: (name) => require(`./Pages/${name}`).default,
      }),
    ),
})
  .use(createPinia())
  .use(Toast, options)
  .mixin({ methods: { route } })
  .use(InertiaPlugin)
  .use(LoadScript)
  .mount(el);

InertiaProgress.init({ color: '#4B5563' });

if (ENVIRONMENT !== 'local') {
  Sentry.init({
    environment: ENVIRONMENT,
    InertiaApp,
    dsn: 'https://93c090dc60c40e01d91dae9b105fbb85@o4506485101232128.ingest.sentry.io/4506485334802432',
    integrations: [
      new Sentry.BrowserTracing({
        tracingOrigins: [APP_DOMAIN, /^\//],
      }),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    logErrors: true,
  });
}
